import { VStack } from "../../styled-system/jsx";
import { buttonRecipe } from "../components/core/basic/Button";

export default () => (
  <VStack>
    <h3>An error occurred.</h3>
    <a href="/" className={buttonRecipe()}>
      Reload
    </a>
  </VStack>
);
